// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"6cbd38f3","453":"d3965fc1"}[chunkId] + ".chunk.js";
};